<script setup lang="ts">
import { computed, toRef } from 'vue'
import { useCta, type CtaOptions } from '@/composables/useCta.ts'
import UiIcon from '@/components/common/UiIcon.vue'

const props = defineProps<{
  options: CtaOptions
}>()

const cta = useCta(toRef(props, 'options'))
const baseClass = computed(() => cta.appearance.value === 'link' ? 'link-ui' : 'btn-ui')
const isInternal = computed(() => cta.isInternal.value)
const isScroll = computed(() => cta.isScroll.value)
const routerTo = computed(() => cta.routerTo.value)
const href = computed(() => cta.href.value)
const target = computed(() => cta.target.value)
const rel = computed(() => cta.rel.value)
const colorClass = computed(() => cta.colorClass.value)
const text = computed(() => cta.text.value)
const iconName = computed(() => cta.icon.value)
const iconPosition = computed(() => cta.iconPosition.value)
</script>

<template>
  <RouterLink
    v-if="isInternal && routerTo"
    :to="routerTo"
    :class="[baseClass, colorClass]"
  >
    <UiIcon
      v-if="iconName && iconPosition === 'left'"
      :name="iconName"
      class="size-6"
    />
    <span v-html="text" />
    <UiIcon
      v-if="iconName && iconPosition !== 'left'"
      :name="iconName"
      class="size-6"
    />
  </RouterLink>

  <button
    v-else-if="isScroll"
    type="button"
    :class="[baseClass, colorClass, 'cursor-pointer']"
    @click="cta.onClick"
  >
    <UiIcon
      v-if="iconName && iconPosition === 'left'"
      :name="iconName"
      class="size-6"
    />
    <span v-html="text" />
    <UiIcon
      v-if="iconName && iconPosition !== 'left'"
      :name="iconName"
      class="size-6"
    />
  </button>

  <a
    v-else
    :href="href"
    :target="target"
    :rel="rel"
    :class="[baseClass, colorClass]"
  >
    <UiIcon
      v-if="iconName && iconPosition === 'left'"
      :name="iconName"
      class="size-6"
    />
    <span v-html="text" />
    <UiIcon
      v-if="iconName && iconPosition !== 'left'"
      :name="iconName"
      class="size-6"
    />
  </a>
</template>
